import { getStyle } from './getStyle';
import { getVSMEText } from '../../../../main/functions/vsme/getVSMEText';
import { IDs } from '../../../../helpers/IDs';
import * as React from 'react';
import { renderTable } from './renderTable';
import { Table } from './Table';
import { WpdfText } from '../../pdf/WpdfText.';
import { WpdfView } from '../../pdf/WpdfView';

export interface ModulBasisProps {
    data: any;
    isPdf?: boolean;
    jahr: number;
    standortTid?: number;
    jsxB3Co2?: JSX.Element;
    getPageNum?: (key: string, page: number, level: number) => void;
}

export class ModulBasis extends React.Component<ModulBasisProps, {}> {

    constructor(props: any) {
        super(props);
        this.state = {
        };
        this.init();
    }

    private flags: any;
    private formatFloat: any = new Intl.NumberFormat('de-DE', { minimumFractionDigits: 0, maximumFractionDigits: 2, useGrouping: true });
    private platzhalter: any;
    private Table: any;

    componentDidUpdate(prevProps: any): void {
        if (this.props.standortTid !== prevProps.standortTid || this.props.jahr !== prevProps.jahr) {
            this.init();
        }
    }

    init(): void {
        const { data, jahr, standortTid } = this.props;
        this.Table = new Table(this.props.data, { jahr: this.props.jahr, standort_tid: this.props.standortTid });
        this.flags = ((((data[IDs.KENNZIFFERN_BERECHNET] || {})[jahr] || {}).vsme || {})[standortTid] || {}).flags || {};
        this.platzhalter = ((((data[IDs.KENNZIFFERN_BERECHNET] || {})[jahr] || {}).vsme || {})[standortTid] || {}).platzhalter || {};
        console.log(this.flags, this.platzhalter);
    }

    isNumber(value: number): boolean {
        return typeof value === 'number' && !isNaN(value);
    }

    render(): JSX.Element {
        return <>
            {this.renderHeading('I) Basismodul', 1)}
            {this.renderB1()}
            {this.renderB2()}
            {this.renderB3()}
            {this.renderB4()}
            {this.renderB5()}
            {this.renderB6()}
            {this.renderB7()}
            {this.renderB8()}
            {this.renderB9()}
            {this.renderB10()}
            {this.renderB11()}
            {this.renderB12()}
        </>;
    }

    renderAbsatz(keys: string[]): JSX.Element {
        const { data, isPdf, jahr, standortTid } = this.props;
        return (
            <WpdfView style={getStyle('div')} pdf={isPdf}>
                <WpdfText pdf={isPdf}>
                    {(keys || []).map((key: string) => getVSMEText(key, data, jahr, standortTid) || '').join(' ')}
                </WpdfText>
            </WpdfView>
        );
    }

    renderB1(): JSX.Element {
        const Table = this.Table;
        let berichtsform: JSX.Element = null;
        Table.processData((IDs.ENT_VSME_B1), null, (item: any) => {
            if (typeof item.bericht === 'string') {
                berichtsform = <>{this.renderAbsatz([`b1_absatz2_${item.bericht}`])}{this.renderB1Standorte()}</>;
            }
        });

        return <>
            {this.renderHeading('B1: Grundlage für die Erstellung', 2)}
            {this.renderAbsatz(['b1_absatz1'])}
            {this.renderB1Module()}
            {berichtsform}
        </>;
    }

    renderB1Module(): JSX.Element {
        const { isPdf } = this.props;
        const module = ['Basis Modul', 'Beschreibendes Modul: Nachhaltigkeitspolitik, Ziele und Maßnahmen', 'Geschäftspartner Modul'];
        return <WpdfView pdf={isPdf} style={{ ...getStyle('div'), ...getStyle('list') }}>
            {module.map((m: string, idx: number) =>
                <WpdfView pdf={isPdf} key={`b1_module_${idx}`} style={{ display: 'flex', flexDirection: 'row' }}>
                    <WpdfText pdf={isPdf} style={{ ...getStyle('list_number') }}>•</WpdfText>
                    <WpdfText pdf={isPdf}>{m}</WpdfText>
                </WpdfView>
            )}
        </WpdfView>
    }

    renderB1Standorte(): JSX.Element {
        const { data, isPdf } = this.props;
        return <WpdfView pdf={isPdf} style={{ ...getStyle('div'), ...getStyle('list') }}>
            {(data[IDs.ENT_STANDORT] || []).map((s: any, idx: number) =>
                <WpdfView pdf={isPdf} key={`b1_standorte_${idx}`} style={{ display: 'flex', flexDirection: 'row' }}>
                    <WpdfText pdf={isPdf} style={{ ...getStyle('list_number') }}>{idx + 1}.</WpdfText>
                    <WpdfText pdf={isPdf}>{[s.standort_typ_tid + ' ' + s.name, s.ort, s.strasse, s.hausnummer].filter((t: string) => !!t).join(', ')}</WpdfText>
                </WpdfView>
            )}
        </WpdfView>
    }

    renderB2(): JSX.Element {
        const b1: any = ((this.props.data || {})[IDs.ENT_VSME_B1] || [])
            .find((item: any) => (item.standort_tid_orig || item.standort_tid) === this.props.standortTid) || {};
        const showPat: boolean = Object.keys(b1).length ? (b1.modul === 'basis_pat' || b1.modul === 'basis_pat_geschaeft') : true;
        const names: any = {
            klimawandel: 'Klimawandel:', umweltverschmutzung: 'Umweltverschmutzung:', wasserressourcen: 'Wasser- und Meeresressourcen:',
            oekosysteme: 'Biologische Vielfalt und Ökosysteme:', kreislaufwirtschaft: 'Kreislaufwirtschaft:',
            eigene_belegschaft: 'Eigene Belegschaft:', arbeitnehmer: 'Arbeitnehmer in der Wertschöpfungskette:',
            gemeinschaften: 'Betroffene Gemeinschaften:', verbraucher: 'Verbraucher und Endnutzer:', geschaeftsgebaren: 'Geschäftsgebaren:'
        };

        return <>
            {this.renderHeading('B2: Nachhaltige Geschäftspraktiken', 2)}
            {showPat
                ? this.renderAbsatz(['b2_absatz1_pat'])
                : <>{this.renderAbsatz(['b2_absatz1'])}{this.renderDatensatz(IDs.ENT_VSME_B2, names, true)}</>
            }
        </>;
    }

    renderB3(): JSX.Element {
        const { data, isPdf, jahr, jsxB3Co2, standortTid } = this.props;
        const b3: any = ((((data[IDs.KENNZIFFERN_BERECHNET] || {})[jahr] || {}).vsme || {})[standortTid] || {}).b3 || {};

        return <>
            {this.renderHeading('B3: Energie- und Treibhausgasemissionen', 2)}
            {b3.energieverbrauch_gesamt !== null
                ? <>
                    {this.renderAbsatz(['b3_absatz1'])}
                    <WpdfView pdf={isPdf} nowrap>{jsxB3Co2}</WpdfView>
                </>
                : this.renderText('keine Angabe')
            }
        </>;
    }

    renderB4(): JSX.Element {
        const { data, isPdf, jahr, standortTid } = this.props;
        const b4: any = ((((data[IDs.KENNZIFFERN_BERECHNET] || {})[jahr] || {}).vsme || {})[standortTid] || {}).b4 || {};
        const Table = this.Table;
        const table: any = {
            rows: [['Schadstoff', 'Verschmutzungskategorie', 'Menge']],
            rowStyles: [[['head', 'bold'], ['head', 'bold'], ['head', 'bold']]]
        };
        Table.processData(IDs.ENT_VSME_B4, null, (item: any) => {
            const kategorien: string = Array.isArray((b4[item.tid] || {}).kategorien) ? b4[item.tid].kategorien.join(' / ') : null;
            const value: string = this.isNumber(item.menge)
                ? `${this.formatFloat.format(item.menge)}${item.einheit ? ` ${item.einheit}` : ''}` : item.menge;
            table.rows.push([item.name, kategorien, value]);
            table.rowStyles.push([, ,]);
        });

        return <>
            {this.renderHeading('B4: Verschmutzung von Luft, Wasser und Boden', 2)}
            {!!this.flags.b4 && this.renderAbsatz(['b4_absatz1_v1'])}
            {!!this.flags.b4 && renderTable(table, isPdf)}
            {!this.flags.b4 && this.renderAbsatz(['b4_absatz1_v2'])}
        </>;
    }

    renderB5(): JSX.Element {
        const { data, isPdf, jahr, standortTid } = this.props;
        const b5: any = ((((data[IDs.KENNZIFFERN_BERECHNET] || {})[jahr] || {}).vsme || {})[standortTid] || {}).b5 || {};
        const Table = this.Table;
        const table: any = {
            rows: [['Landnutzungstyp', this.props.jahr - 1, this.props.jahr, 'Entwicklung']],
            rowStyles: [
                [
                    [['head', 'bold', 'top'], { flexBasis: '40%' }], [['head', 'bold', 'center', 'top'], { flexBasis: '20%' }],
                    [['head', 'bold', 'center', 'top'], { flexBasis: '20%' }], [['head', 'bold', 'center'], { flexBasis: '20%' }]
                ]
            ]
        };
        const names: any = {
            jahr_flaeche_nutzung: 'Unternehmensfläche gesamt', jahr_flaeche_versiegelt: 'Versiegelte Fläche',
            jahr_flaeche_naturnah_standort: 'Naturnahe Fläche', jahr_flaeche_naturnah_ausserhalb: 'Naturnahe Flächen nicht am Standort',
            grundstuecksflaeche: 'Flächenanteile in/nahe Naturschutzgebiet'
        };
        const getValue = (key: string, item: any) => this.isNumber(item[key]) ? this.formatFloat.format(item[key]) : item[key];
        let einheit: string = '';

        Object.keys(names).forEach((key: string) => {
            table.rows.push([names[key], '', '', '']);
            table.rowStyles.push([
                { flexBasis: '40%' }, ['center', { flexBasis: '20%' }], ['center', { flexBasis: '20%' }], ['center', { flexBasis: '20%' }]
            ]);
        });
        Table.processData(IDs.ENT_VSME_B5, { jahr: null }, (item: any) => {
            const index: number = item.jahr === this.props.jahr ? 2 : (item.jahr === this.props.jahr - 1 ? 1 : 0);

            if (index) {
                einheit = einheit || Table.getValue('einheit');
                table.rows[0][3] = `Entwicklung\n[${einheit} / %]`;
                table.rows[0][index] = `${item.jahr}\n[${Table.getValue('einheit')}]`;

                Object.keys(names).forEach((key: string, i: number) => {
                    table.rows[i + 1][index] = getValue(key, item);
                });
            }

            if (index === 2) {
                Object.keys(names).forEach((key: string, i: number) => {
                    if (key === 'grundstuecksflaeche') {
                        return;
                    }
                    const veraenderung: number = b5[`vor${key}_veraenderung`];
                    const prozent: number = b5[`vor${key}_veraenderung_prozent`];
                    const vorzeichen: string = veraenderung > 0 ? '+ ' : (veraenderung < 0 ? '- ' : '');
                    table.rows[i + 1][3] = veraenderung
                        ? `${vorzeichen}${this.formatFloat.format(Math.abs(+veraenderung))} / ${this.formatFloat.format(Math.abs(+prozent))} %`
                        : '';
                    table.rowStyles[i + 1][3][1] = {
                        ...(table.rowStyles[i + 1][3][1] || {}),
                        ...(vorzeichen && vorzeichen === '+ '
                            ? { color: 'green' }
                            : (vorzeichen && vorzeichen === '- ' ? { color: 'red' } : {})
                        )
                    };
                });
            }
        });

        return <>
            {this.renderHeading('B5: Biologische Vielfalt', 2)}
            {this.renderAbsatz(['b5_absatz1'])}
            {renderTable(table, isPdf)}
            {false && this.renderAbsatz(['b5_absatz2'])}
        </>;
    }

    renderB6(): JSX.Element {
        const { isPdf } = this.props;
        const Table = this.Table;
        const table: any = {
            rows: [['Standort ', 'Wasserstress-Gefährdung']],
            rowStyles: [[['head', 'bold'], ['head', 'bold']]]
        };
        Table.processData(IDs.ENT_VSME_B6, null, (item: any) => {
            table.rows.push([item.standort_tid, Table.getValue('modus')]);
            table.rowStyles.push([,]);
        });

        return <>
            {this.renderHeading('B6: Wasser', 2)}
            {this.renderAbsatz([
                'b6_absatz1_satz1',
                ...(this.flags['b6.regen'] ? ['b6_absatz1_satz2'] : []),
                ...(table.rows.length > 1 ? ['b6_absatz1_satz3'] : [])
            ])}
            {table.rows.length > 1 && renderTable(table, isPdf)}
        </>;
    }

    renderB7(): JSX.Element {
        const { data, isPdf, jahr, standortTid } = this.props;
        const b7: any = ((((data[IDs.KENNZIFFERN_BERECHNET] || {})[jahr] || {}).vsme || {})[standortTid] || {}).b7 || {};
        const Table = this.Table;
        const table: any = {
            rows: [['Abfall-Art', 'Abfall-Menge', 'Gefährlicher Abfall']],
            rowStyles: [[['head', 'bold'], ['head', 'bold'], ['head', 'bold']]]
        };
        Table.processData(IDs.ENT_CO2_SCOPE3_ABFALL, null, (item: any) => {
            const kategorie: string = item.kategorie || null;
            const unit: string = Table.getUnit();
            const menge: string = this.isNumber((b7[kategorie] || {}).menge)
                ? `${this.formatFloat.format(b7[kategorie].menge)}${unit ? ` ${unit}` : ''}`
                : (b7[kategorie] || {}).menge || '';
            table.rows.push([Table.getValue('kategorie'), menge, 'nein']);
            table.rowStyles.push([, ,]);
        });

        return <>
            {this.renderHeading('B7: Ressourcennutzung und Abfallmanagement', 2)}
            {this.renderAbsatz([
                'b7_absatz1_satz1',
                ...(parseFloat(this.platzhalter['b7.recycling_anteil']) > 0 ? ['b7_absatz1_satz2_recycling'] : []),
                ...(parseFloat(this.platzhalter['b7.stoff_anteil']) > 0 ? ['b7_absatz1_satz2_stoff'] : []),
                ...(parseFloat(this.platzhalter['b7.abfall_gesamt']) > 0 ? ['b7_absatz1_satz3'] : []),
            ])}
            {table.rows.length > 1 && renderTable(table, isPdf)}
        </>;
    }

    renderB8(): JSX.Element {
        return <>
            {this.renderHeading('B8: Arbeitskräfte: Allgemeine Merkmale', 2)}
            {this.renderAbsatz(['b8_absatz1'])}
        </>;
    }

    renderB9(): JSX.Element {
        return <>
            {this.renderHeading('B9: Arbeitskräfte - Gesundheit/Sicherheit', 2)}
            {this.renderAbsatz(['b9_absatz1'])}
            {this.renderAbsatz(['b9_absatz2'])}
            {this.renderAbsatz(['b9_absatz3'])}
        </>;
    }

    renderB10(): JSX.Element {
        return <>
            {this.renderHeading('B10: Arbeitskräfte - Entlohnung/Bildung', 2)}
            {this.renderAbsatz(['b10_absatz1'])}
        </>;
    }

    renderB11(): JSX.Element {
        const names: any = {
            prozess: 'Beschreibung Prozess', auswirkungen: 'Art der Auswirkung', betroffene_orte: 'Betroffene Orte',
            betroffene_gruppen: 'Betroffene Gruppen'
        };
        const datensatz: JSX.Element = this.renderDatensatz(IDs.ENT_VSME_B11, names);

        return <>
            {this.renderHeading('B11: Beschäftigte in der Wertschöpfungskette', 2)}
            {datensatz ? this.renderAbsatz(['b11_absatz1']) : this.renderAbsatz(['b11_absatz1_v2'])}
            {datensatz}
        </>;
    }

    renderB12(): JSX.Element {
        return <>
            {this.renderHeading('B12: Verurteilung und Geldstrafen', 2)}
            {this.flags['b12'] ? this.renderAbsatz(['b12_absatz1_satz1', 'b12_absatz1_satz2']) : this.renderAbsatz(['b12_absatz1_v2'])}
        </>;
    }

    renderDatensatz(entity: string, names: any, forced?: boolean): JSX.Element {
        const { isPdf } = this.props;
        const elements: JSX.Element[] = [];
        const Table = this.Table;
        const addElement = (key: string, item: any, index: number) => {
            elements.push(
                <WpdfView key={`datensatz-${index}`} style={{ display: 'flex', flexDirection: 'column' }} pdf={isPdf}>
                    <WpdfView
                        style={{
                            display: 'flex', flexDirection: 'row', alignItems: 'baseline', marginTop: index ? '20pt' : 0,
                            ...(isPdf && { width: '90%' })
                        }}
                        pdf={isPdf}
                    >
                        <WpdfText style={getStyle('list_number')} pdf={isPdf}>•</WpdfText>
                        <WpdfText style={getStyle('bold', isPdf)} pdf={isPdf}>{names[key]}</WpdfText>
                    </WpdfView>
                    <WpdfText style={{ marginLeft: '20pt' }} pdf={isPdf}>{item[key] || 'Keine Angabe'}</WpdfText>
                </WpdfView>
            );
        };
        Table.processData(entity, null, (item: any) => {
            Object.keys(names).forEach((key: string, index: number) => {
                if (typeof item[key] === 'undefined') {
                    return;
                }
                addElement(key, item, index);
            });
        });

        if (!elements.length && forced) {
            Object.keys(names).forEach((key: string, index: number) => addElement(key, {}, index));
        }

        return elements.length
            ? <WpdfView style={{ ...getStyle('div'), ...getStyle('list') }} pdf={isPdf}>{elements}</WpdfView>
            : null;
    }

    renderHeading(name: string, level: number): JSX.Element {
        const { isPdf, getPageNum } = this.props;
        const style: React.CSSProperties = level === 1 ? getStyle('h1') : level === 2 ? getStyle('h2') : {};

        return (
            <WpdfView style={{ ...style }} pdf={isPdf}>
                <WpdfText
                    pdf={isPdf}
                    getPageNum={(pageNumber: number) => typeof getPageNum === 'function' && getPageNum(name, pageNumber, level)}
                >
                    {name || ''}
                </WpdfText>
            </WpdfView>
        );
    }

    renderText(text: string): JSX.Element {
        const { isPdf } = this.props;

        return (
            <WpdfView style={getStyle('div')} pdf={isPdf}>
                <WpdfText pdf={isPdf}>{text || ''}</WpdfText>
            </WpdfView>
        );
    }
}
